import { Button } from 'antd';

import { useRedirect, useUserRole } from 'hooks';

import { Links } from 'links';

export const NewProductButton = () => {
  const handleRedirect = useRedirect();

  const { isAdmin } = useUserRole();

  if (!isAdmin) {
    return null;
  }

  return (
    <Button
      type='primary'
      onClick={handleRedirect(`${Links.Products}/new`)}
    >
      New Product
    </Button>
  );
};
